var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ais-state-results',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function({ state }){return [(_vm.hasRefinements(state))?_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("t")('Yes')))])]):_c('div')]}}])},'ais-state-results',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }